import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import type React from "react";
import { Navigate, useLocation } from "react-router-dom";

type Role = "SUPERUSER" | "ADMIN" | "EMPLOYEE";

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: Role[];
}

export const ProtectedRoute = ({ children, roles }: ProtectedRouteProps) => {
  const { isAuthenticated, user, loading } = useAuth(); //Récupère les infos d'authentification depuis le contexte global
  const location = useLocation();

  if (loading) {
    return (
      <div className="p-6 text-center">
        <Loader2 className="h-4 w-4 animate-spin text-primary mx-auto" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Ne pas passer window.location : non sérialisable → DataCloneError sur replaceState.
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (roles && user?.role && !roles.includes(user.role)) {
    // si le user a un role et que ce role n'est pas dans les roles autorisés, on redirige vers le dashboard du role correspondant
    return (
      <Navigate
        to={
          user.role === "SUPERUSER"
            ? "/superuser/dashboard"
            : "/admin/dashboard"
        }
        replace
      />
    );
  }

  return <>{children}</>;
};
